import { LinkV2, styled } from '@withjoy/joykit';

export const StyledLinkV2 = styled(LinkV2)`
  text-decoration: none;
  color: white;
  &:visited {
    color: white;
  }
  &:hover {
    color: ${props => props.theme.colors.mono5};
  }
  &:active {
    color: white;
  }
`;
